export const hideControlsClassName = 'mvng-hide-controls';
